module.exports = __webpack_public_path__ + "img/15-9.d6d92a2d.png";